'use client';

import React from "react";

type NavigationButtonsFakeProps = {
  text: string;
  stepIsValidated: boolean;
  type?: "button" | "submit" | "reset" | undefined
  onClick?: () => Promise<void> | void;
  color?: string;
};

export const NavigationButtonsFake = ({
  stepIsValidated,
  text,
  type = "button",
  onClick,
  color,
}: NavigationButtonsFakeProps) => {

  const [isLoading, setIsLoading] = React.useState(false);

  const renderClass = () => {
    if (color && color === 'blue') {
      if (!stepIsValidated) {
        return 'text-smokeH bg-primaryBlue700';
      } else {
        return 'text-smokeH bg-primaryBlue700 hover:bg-primaryBlue600';
      }
    } else if (color && color === 'inverted') {
      return 'bg-smokeH text-primaryBlue700 border-2 border-primaryBlue700';
    } else {
      if (!stepIsValidated) {
        return 'text-smokeH bg-primaryBlue700';
      } else {
        return 'text-smokeH bg-primaryBlue700 hover:bg-primaryBlue600';
      }
    }
  };

  const handleClick = async () => {

    setIsLoading(true);

    try {
      if (onClick) {
        await onClick()
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="flex justify-center w-full">
      <button
        type={type}
        aria-label="go forward"
        onClick={handleClick} // Call the onClick function passed as a prop
        disabled={isLoading || !stepIsValidated}
        className={`rounded-lg  flex justify-center items-center font-semibold p-4 w-full text-lg ${renderClass()}`}
      >
        {text}
      </button>
    </div>
  );
};
